var map = {
	"./Aeschines_British_Museum.png": "64cf",
	"./Anisthenes_Pio-Clementino.png": "10ff",
	"./Apollodorus_Damascus_Glyptotek.png": "8899",
	"./Bias_villa_Cassius.png": "63f6",
	"./Corinth_Periander_Vaticano.png": "e580",
	"./Herodotos_Metropolitan.png": "f067",
	"./Pittacos_Louvre.png": "058a",
	"./Pythagoras_Borghese.png": "9aef",
	"./Pytheas.png": "a444",
	"./Sappho_Musei_Capitolini.png": "e965",
	"./bg_3.png": "c0f3",
	"./book_1.png": "ef46",
	"./book_2.png": "a792",
	"./clear.png": "c0dc",
	"./image_2024_11_04T08_31_28_265Z.png": "e5a8",
	"./image_2024_11_04T08_31_33_904Z.png": "92aa",
	"./left.png": "f64e",
	"./logo.png": "4ffd",
	"./logo_GR.png": "1080",
	"./logo_GR3x.png": "60fa",
	"./logo_white.png": "0bc8",
	"./photo_books_1.png": "af89",
	"./photo_books_2.png": "ab15",
	"./photo_books_3.png": "91b5",
	"./photo_books_4.png": "e94a",
	"./photo_books_5.png": "bcad",
	"./play.png": "d99c",
	"./published.png": "b440",
	"./published_white.png": "2391",
	"./right.png": "d2ff",
	"./search.png": "1e5e",
	"./written.png": "ab87",
	"./written_white.png": "d120"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7016";